module.exports = __webpack_public_path__ + "innovation.png?8ef24d8509db1e2525cf6b845a0252b7";